import { useMutation, useQueryClient } from "react-query";
import { EExercisesQueryKeys } from "api/endpoints/exercises";
import { addHomeworkExercise } from "api/services/exercises";
import { logError } from "utils/notifications";
import { TApiError } from "types/api/error";
import { TAddExercise, TExercise } from "types/api/exercise";
import { TUrlParam } from "types/utils";

export const useAddHomeworkExercise = <
  TPayload = Record<string, unknown>,
  TText extends string = string
>(
  courseId: TUrlParam,
  lessonId: TUrlParam,
  homeworkId: TUrlParam
) => {
  const queryClient = useQueryClient();
  return useMutation<
    TExercise<TPayload, TText>,
    TApiError,
    TAddExercise<TPayload, TText>
  >(
    (homeworkExercise: TAddExercise<TPayload, TText>) =>
      addHomeworkExercise<TPayload, TText>(
        courseId,
        lessonId,
        homeworkId,
        homeworkExercise
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(EExercisesQueryKeys.getHomeworkExercises);
      },
      onError: (error) => logError({ error }),
      retry: false,
    }
  );
};
